<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'conta' ? 'active' : ''" @click.prevent="abrir('conta')">
                        Contas
                    </a>
                </li>
            </ul>
        </div>

        <guias tipo="auditoria" :id_usuario="id_usuario" v-if="aba == 'conta'"/>
    </div>
</template>

<script>
import Guias from '../faturamento/Guias.vue';

export default {
    components: { 
        Guias,
    }, 

    props: ['id_usuario', 'status', 'aba'],

    methods: {
        abrir(aba) {
            if ( aba != this.aba ) {
                this.$router.push({ path: '/auditoria/' + aba });
            }
        },
    }
}
</script>